import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      component: () => import("@/views/index"),
      meta: { requiresAuth: true },
    },
    {
      path: "/gedicht/:id",
      component: () => import("@/views/poem"),
    },
    {
      path: "/login",
      component: () => import("@/views/login"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const token = localStorage.getItem("token");
  if (requiresAuth && !token) {
    next("/login");
  } else {
    next();
  }
});

export default router;
